import { TabStyles } from '@tableau/widgets';
import * as _ from 'underscore';
import { cssClass } from '../../../style';
import { PermissionsGridStyles } from './PermissionsGridStyle';

export namespace AddNewPermissionStyles {
  export const addNewPermissionCssPrefix = 'AddNewPermission';
  export const buttonContainer = 'button-container';
  export const ButtonTopMargin = 12;

  export type AddNewPermissionContainerStyleArgs = {
    numAddedRows: number;
    numRows: number;
    inEditMode: boolean;
    searching: boolean;
  };

  export let memoizedButtonContainer = _.memoize(ButtonContainer, (args) => { return JSON.stringify(args); });
  export function ButtonContainer(args: AddNewPermissionContainerStyleArgs): string {
    let marginTop = ButtonTopMargin;
    // if extra rows were added to the permissions grid, a negative margin needs to be added to the AddPermission
    // so that it does not get forced downwards
    if (args.searching) {
        let numAboveMaxRows = 0;
        if (args.numRows - 1 > PermissionsGridStyles.MaxRows) {
          numAboveMaxRows = args.numRows - 2 - PermissionsGridStyles.MaxRows;
        } else {
          numAboveMaxRows = args.numRows - PermissionsGridStyles.MaxRows;
        }
        marginTop = ButtonTopMargin - PermissionsGridStyles.RowHeight * (args.numAddedRows + numAboveMaxRows);
      marginTop -= PermissionsGridStyles.GranteeSearchFieldPopupTotalHeight;
    } else if (args.inEditMode && args.numAddedRows === 1) {
      // last row is in edit mode. Depending on if there are more than the max number of rows,
      // we also need to account for the header row
      const addedRows = args.numRows - 1 > PermissionsGridStyles.MaxRows ? 1 : 2;
      marginTop = ButtonTopMargin - PermissionsGridStyles.RowHeight * addedRows;
    }
    return cssClass(addNewPermissionCssPrefix, buttonContainer, {
      marginTop: `${marginTop}px`,
    });
  }

  export const ButtonContent = cssClass(addNewPermissionCssPrefix, 'button-content', {
    alignItems: 'center',
    display: 'inline-flex',
    verticalAlign: 'middle',
  });
}
